import script from "./InfoPop.vue?vue&type=script&lang=ts&setup=true"
export * from "./InfoPop.vue?vue&type=script&lang=ts&setup=true"

import "./InfoPop.vue?vue&type=style&index=0&id=48c28114&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48c28114"]])

export default __exports__